import React, { useEffect, useRef } from 'react';

const ChaosToOrder = ({ showLabels = true, opacity = 1 }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const setCanvasSize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    setCanvasSize();
    window.addEventListener('resize', setCanvasSize);

    // Animation parameters
    let progress = 0;
    const numLines = 25;
    const lines = [];

    // Initialize chaotic lines
    for (let i = 0; i < numLines; i++) {
      const startY = (canvas.height / numLines) * i + Math.random() * 20;
      lines.push({
        startX: 0,
        startY: startY,
        endX: canvas.width,
        endY: startY,
        chaosPoints: generateChaosPoints(canvas.width, startY)
      });
    }

    function generateChaosPoints(width, baseY) {
      const points = [];
      const segments = 50;
      for (let i = 0; i <= segments; i++) {
        const x = (width / segments) * i;
        const chaosY = baseY + (Math.random() - 0.5) * 120 * Math.sin(i * 0.4);
        points.push({ x, chaosY, orderY: baseY });
      }
      return points;
    }

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      progress += 0.002;
      if (progress > 1) progress = 0;

      const easedProgress = easeInOutCubic(progress);

      lines.forEach((line, index) => {
        ctx.beginPath();
        ctx.strokeStyle = `rgba(201, 162, 39, ${(0.3 + easedProgress * 0.6) * opacity})`;
        ctx.lineWidth = 2;

        line.chaosPoints.forEach((point, i) => {
          const y = point.chaosY + (point.orderY - point.chaosY) * easedProgress;
          if (i === 0) {
            ctx.moveTo(point.x, y);
          } else {
            ctx.lineTo(point.x, y);
          }
        });

        ctx.stroke();
      });

      requestAnimationFrame(animate);
    }

    animate();

    return () => {
      window.removeEventListener('resize', setCanvasSize);
    };
  }, [opacity]);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <canvas
        ref={canvasRef}
        style={{
          width: '100%',
          height: '100%',
          display: 'block'
        }}
      />
      {showLabels && (
        <>
          <div style={{
            position: 'absolute',
            top: '20px',
            left: '20px',
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '0.875rem',
            fontWeight: 700,
            color: 'rgba(184, 216, 218, 0.6)',
            textTransform: 'uppercase',
            letterSpacing: '0.1em'
          }}>
            Chaos
          </div>
          <div style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '0.875rem',
            fontWeight: 700,
            color: '#C9A227',
            textTransform: 'uppercase',
            letterSpacing: '0.1em'
          }}>
            Order
          </div>
        </>
      )}
    </div>
  );
};

export default ChaosToOrder;